import moment from "moment";

//! moment.js locale configuration
//! locale : Haitian Creole [ht]
//! Hand-authored: moment ships no `ht` locale. Names are sourced from
//! config/locales/dates.ht.yml — keep the two in sync.

(function (moment) {
  "use strict";

  var ht = moment.defineLocale("ht", {
    months: "janvye_fevriye_mas_avril_me_jen_jiyè_out_septanm_oktòb_novanm_desanm".split("_"),
    monthsShort: "jan_fev_mas_avr_me_jen_jiy_out_sep_okt_nov_des".split("_"),
    weekdays: "dimanch_lendi_madi_mèkredi_jedi_vandredi_samdi".split("_"),
    weekdaysShort: "dim_len_mad_mèk_jed_van_sam".split("_"),
    weekdaysMin: "di_le_ma_mè_je_va_sa".split("_"),
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY h:mm A",
      LLLL: "dddd D MMMM YYYY h:mm A",
    },
    week: {
      dow: 1, // Monday is the first day of the week
      doy: 4,
    },
  });

  return ht;
})(moment);
